import { createReducer } from '@reduxjs/toolkit';

import actionCoOrder, { clearActionCoOrder } from '../../../thunks/coilovers/orders/actionCoOrder';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const actionCoOrderReducer = createReducer(initialState, {
  [actionCoOrder.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [actionCoOrder.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [actionCoOrder.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearActionCoOrder]: () => initialState
});

export default actionCoOrderReducer;
